//© all rights reserved to 6over6 Ltd. 2022. This software (the "Software") is the property of 6over6 Ltd. and its licensors. Any use of the Software is strictly prohibited unless an explicit license or permission is granted by 6over6 Ltd.
import CallbackEnums from "../enums/CallbackEnums";
import AnalyticsEvent from "../models/AnalyticsEvent";
import AnalyticsLogger from "./AnalyticsLogger";
import ErrorLogger from "./ErrorLogger";

class _callbackService {
  constructor() {
    this.callbacks = {};
    this.analyticsLogger = AnalyticsLogger;
    this.logger = ErrorLogger;
    this.store = null;
  }

  setStore(store) {
    this.store = store;
  }

  setCallback(name, callback = function () {}) {
    this.callbacks[name] = callback;
  }

  handleCallback(name, event) {
    const callback = this.callbacks[name];
    if (callback) {
      if (name == CallbackEnums.RESULTS) {
        this.analyticsLogger.log(new AnalyticsEvent("pv web result callback"));
      }
      try {
        callback(event);
      } catch (err) {
        this.logger.log("Err in callback " + name + ": " + err.message);
        throw err;
      }
    }
  }

  reportAnalytics(title, description) {
    if (!this.callbacks.analytics) {
      return;
    }
    let event = {
      title: title,
      description: description,
      tag: this.store.state.Session.tag,
    };
    this.callbacks.analytics(event);
  }

  unsuccessfulFlowBtnClick() {
    if (!this.callbacks.unsuccessfulFlowBtn) {
      return;
    }
    this.callbacks.unsuccessfulFlowBtn();
  }

  onUnauthorizedFlow() {
    if (!this.callbacks.unauthorizedFlow) {
      return;
    }
    this.callbacks.unauthorizedFlow();
  }

  onResult(result, flowId = this.store.state.Session.flowId) {
    let returnedResult = {
      id: `${this.store.state.Session.userId}/${this.store.state.Session.sessionId}`,
      l_sph: result.l_sph,
      r_sph: result.r_sph,
      l_cyl: result.l_cyl,
      r_cyl: result.r_cyl,
      l_axis: result.l_axis,
      r_axis: result.r_axis,
      pd: result.pd,
      is_pd_oor: result.is_pd_oor,
      error_type: result.error_type,
      lens_width: result.frame_width, // note, the server still return the result in frame_width field for backwards compatibility, web versions from 2.6.0 and above convert it to lens_width field
      frame_data: result.frame_data,
      note: result.note,
    };
    let status;
    if (result.error || result.status == "incomplete") {
      status = "copy-glass.prescription-incomplete";
    } else {
      //system web
      status = "copy-glass.prescription-ready";
      AnalyticsLogger.log(
        new AnalyticsEvent("system web " + flowId + " success")
      );
    }

    let data = { status: status, data: returnedResult };
    this.store.state.results = data;
    if (this.callbacks.result) {
      AnalyticsLogger.log(
        new AnalyticsEvent("system web result callback " + status)
      );
      try {
        this.callbacks.result(data);
      } catch (err) {
        ErrorLogger.log("Error in Result callback" + err.message);
        throw err;
      }
    }
  }

  onClose(results) {
    if (!this.callbacks.close) {
      return;
    }

    this.callbacks.close(results);
  }
}

const CallbackService = new _callbackService();
export default CallbackService;
